import React from 'react';
import { useLocation } from 'react-router';

export default function useIsReadonlyPath() {
  const l = useLocation();
  if (l.pathname.includes('readonly')) return true;
  return false;
}
